// extracted by mini-css-extract-plugin
export default {"color":"f79673","color--grey":"d1eee0","notification":"c699c0","notification__title":"b20701","notification__notice":"bff821"};